/**
 * The front door (D-193): a first visit lands on Welcome; a phone that has been signed in before lands on Sign in.
 * The note lives on this device only (a returning player on a new phone sees Welcome once, which still offers Sign in).
 */
const KEY = "digu.returning";

export function markReturning(): void { try { localStorage.setItem(KEY, "1"); } catch { /* private window */ } }
export function isReturning(): boolean { try { return localStorage.getItem(KEY) === "1"; } catch { return false; } }
/** Where a signed-out visit to a signed-in page goes. */
export const frontDoor = (): "/signin" | "/welcome" => (isReturning() ? "/signin" : "/welcome");

/** Lessons anyone can play without an account; the rest ask to sign in. */
export const PUBLIC_LESSONS = ["turn", "groups", "digu"] as const;
export const isPublicLesson = (id: string): boolean => (PUBLIC_LESSONS as readonly string[]).includes(id);
